module.exports = __webpack_public_path__ + "static/media/flag-ha.da2d9d49.webp";